import { ConfigWrapper } from "@/common/components/ConfigWrapper";
import "@/styles/index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigWrapper />
  </StrictMode>
);
